import { render, staticRenderFns } from "./gptLogin.vue?vue&type=template&id=aa12c07e&scoped=true&"
import script from "./gptLogin.vue?vue&type=script&lang=js&"
export * from "./gptLogin.vue?vue&type=script&lang=js&"
import style0 from "./gptLogin.vue?vue&type=style&index=0&id=aa12c07e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa12c07e",
  null
  
)

export default component.exports